export default function getDomainFromUrl(url: string | undefined) {
  if (!url) return '';

  try {
    return new URL(url).hostname;
  } catch {
    return '';
  }
}
